import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from '../../service/connection.service';
import { environment } from '../../../environments/environment';
import { foldPackagesIntoServices } from '../../utility/packages-migration';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'app-team-evento',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './team-evento.component.html',
  styleUrl: './team-evento.component.css',
})
export class TeamEventoComponent implements OnInit {
  event: any = null;
  loading = true;
  error = '';
  eventId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private connection: ConnectionService,
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) { this.router.navigate(['/team/matrimoni']); return; }
    this.eventId = id;

    this.connection.get(
      `@events/${id}`,
      (data: any) => {
        foldPackagesIntoServices(data); // retro-compat pacchetti → servizi
        this.event = data;
        this.loading = false;
      },
      (err: any) => {
        this.error = err?.status === 403 ? 'Non hai accesso a questo evento.' : 'Evento non trovato.';
        this.loading = false;
      },
    );
  }

  formatDate(d: string): string {
    if (!d) return '—';
    const [y, m, day] = d.split('-');
    return `${day}/${m}/${y}`;
  }

  get teamPeople(): any[] {
    return this.event?.schedule?.team?.people ?? [];
  }

  // Visibilità sezioni per il team (risolta dal backend in event._visibility.team)
  canSee(section: string): boolean {
    return this.event?._visibility?.team?.[section] ?? false;
  }

  get gallery(): any[] {
    return (this.event?.image?.gallery ?? []).map((g: any) =>
      typeof g === 'string' ? { key: g } : g,
    );
  }

  get selectedServices(): any[] {
    return (this.event?.event?.services ?? []).filter((s: any) => s.selected);
  }

  get partecipanti(): any[] {
    return this.event?.schedule?.partecipanti ?? [];
  }

  getImageUrl(key: string): string {
    return `${environment.apiUrl}/events/${this.eventId}/image?key=${encodeURIComponent(key)}`;
  }

  myEmail(): string {
    try {
      const token = localStorage.getItem('token') ?? '';
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.email ?? '';
    } catch { return ''; }
  }

  isMe(person: any): boolean {
    return person.email === this.myEmail();
  }

  back() {
    this.router.navigate(['/team/matrimoni']);
  }
}
